export function formatSan(san: string | number) {
    return String(san)
        .replace(/\s|-|_|\(|\)/g, '')
        .toLocaleLowerCase();
}
